var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"control-square",on:{"mousedown":function($event){return _vm.mouseDown(true)},"mouseup":function($event){return _vm.mouseUp()}}},[_c('div',{staticClass:"text-lg font-bold"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }